// #/services/registry/zodFromJson/zodSchemaFromJsonSchema.ts

import { ZodSchema, z, ZodTypeAny } from 'zod';

export function zodSchemaFromJsonSchema(schema: any): ZodSchema | null {
  try {
    console.debug('zodSchemaFromJsonSchema(schema:', schema, ');');

    if (schema == null) {
      return null;
    }

    // Array
    if (Array.isArray(schema)) {
      // Handle array schema
      // const subschemas = schema.map((s: any) => {
      //   if (s == null) {
      //     throw new Error('Null schema in array');
      //   }
      //   return zodSchemaFromJsonSchema(s);
      // });
      const subschemas: ZodTypeAny[] = [];
      for (const s of schema) {
        if (s == null) {
          throw new Error('Null schema in array');
        }
        const subschema = zodSchemaFromJsonSchema(s);
        if (subschema == null) {
          throw new Error('Null schema in array');
        }
        subschemas.push(subschema);
      }
      if (subschemas.length === 0) {
        throw new Error('Empty array schema');
      }
      return z.tuple(subschemas as [] | [ZodTypeAny, ...ZodTypeAny[]]);
    }

    // Object
    if (typeof schema === 'object') {
      if (schema?.oneOf != null) {
        return z.string();
        // return z.union(
        //   schema?.oneOf.map((s: any) => zodSchemaFromJsonSchema(s)),
        // );
      }

      if (schema?.type === 'array' && schema?.itemSchema != null) {
        const zodItemSchema = zodSchemaFromJsonSchema(schema.itemSchema);
        if (zodItemSchema == null) {
          throw new Error('Null item schema for array');
        }
        return z.array(zodItemSchema);
      }

      // Handle object schema

      const properties = schema?.properties;
      const required = schema?.required ?? [];

      const parsedProperties: { [key: string]: ZodSchema<any> } = {};

      if (properties == null) {
        // return z.object({});

        const schemaEntries = Object.entries(schema);
        if (schemaEntries.length === 0) {
          throw new Error('Empty object schema');
        }
        for (const [propertyName, propertySchema] of schemaEntries) {
          if (propertySchema == null) {
            continue;
          }
          const zodPropertySchema = zodSchemaFromJsonSchema(propertySchema);
          if (propertyName != null && zodPropertySchema != null) {
            parsedProperties[propertyName] = zodPropertySchema;
          }
        }

        return z.object(parsedProperties);
      }

      const propEntries = Object.entries(properties);
      if (propEntries.length === 0) {
        throw new Error('No properties found for object schema');
      }
      for (const [propertyName, propertySchema] of propEntries) {
        if (propertySchema == null) {
          continue;
        }
        const zodPropertySchema = zodSchemaFromJsonSchema(propertySchema);
        if (propertyName != null && zodPropertySchema != null) {
          if (required.includes(propertyName)) {
            parsedProperties[propertyName] = zodPropertySchema;
          } else {
            // TODO: optional fields (requires support from dynamic form)
            // zodPropertySchema.optional();
          }
        }
      }

      return z.object(parsedProperties);
    }

    // Primitive
    switch (schema) {
      case 'null': {
        return z.null();
      }
      case 'string': {
        return z.string();
      }
      case 'number': {
        return z.number();
      }
      case 'boolean': {
        return z.boolean();
      }
      case 'integer':
      case 'bigint': {
        return z.number().int();
      }
      case 'object': {
        return z.record(z.any());
      }
      case 'any': {
        return z.any();
      }
      // Add additional primitive types as needed
      default:
        throw new Error(`Unsupported schema type: ${schema}`);
    }
  } catch (error: any) {
    console.error(error);
    throw new Error(`zod from json error: ${error.message}`);
  }
}
